import { isAxiosError } from "axios";

/**
 * Extracts a safe, user-facing message from a failed API call, matching
 * the backend's `ErrorResponse` envelope (`{error: {code, message,
 * details, request_id, correlation_id}}`, `backend/src/api/schemas.py`).
 * Only ever surfaces `error.message` - never `details`, `request_id`, or
 * any other field that could leak internal state - and falls back to a
 * generic message for anything that isn't a recognizable API error
 * (network failure, timeout, unexpected shape).
 */
export function extractApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const body = error.response?.data as { error?: { message?: unknown } } | undefined;
    if (body?.error && typeof body.error.message === "string" && body.error.message.length > 0) {
      return body.error.message;
    }
  }
  return fallback;
}
